import { serviceVersion, serviceApiRoots } from './../../config/config/config.constants';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from './../../config/config/config.service';
import { UtilityCookieService as utilityCookie } from '../../utils/cookie/utilitycookie.service';
import * as i0 from "@angular/core";
import * as i1 from "../../config/config/config.service";
import * as i2 from "@angular/common/http";
export class ApiService {
    constructor(config, http) {
        this.config = config;
        this.http = http;
    }
    getServiceUrl(serviceName) {
        let rootUrl;
        if (this.config.get('useJson')) {
            // console.log('useJson', serviceName)
            // if (serviceName === 'getOrderDetails') {
            //   if (localStorage.approved) {
            //     serviceName = serviceName + '-approved';
            //   }
            //
            // }
            rootUrl = this.config.get('apiRoot') + serviceName + '.json';
        }
        else {
            rootUrl = serviceApiRoots.get(serviceName) ? serviceApiRoots.get(serviceName) : this.config.get('apiRoot');
            const isGetRxHistoryCookie = (utilityCookie.getCookie('getRxHistoryUpdated') === 'on');
            if (serviceName === 'getRxHistory') {
                rootUrl = rootUrl + (isGetRxHistoryCookie ? '1.2.0/' : '1.1.0/') + serviceName;
            }
            else if (serviceName !== 'RxAuthChallenge' && serviceName !== 'SubmitRxChallenge' && serviceName !== 'webContent') {
                rootUrl = rootUrl + serviceName;
            }
        }
        return rootUrl;
    }
    getVersion(serviceName) {
        const version = serviceVersion.get(serviceName) ? serviceVersion.get(serviceName) : this.config.get('version');
        return version;
    }
    getDefaultQueryParams(serviceName, opName, modifyParams) {
        const req = {};
        req['version'] = this.getVersion(serviceName);
        req['appName'] = modifyParams ? 'ICE_WEB' : this.config.getAppName();
        req['serviceName'] = serviceName;
        req['operationName'] = opName;
        req['deviceType'] = modifyParams ? 'DESKTOP' : this.config.getDeviceType();
        req['channelName'] = modifyParams ? 'WEB' : this.config.get('channelName');
        req['lineOfBusiness'] = this.config.get('lineOfBusiness');
        req['deviceToken'] = this.config.get('deviceToken');
        req['xmlFormat'] = this.config.get('xmlFormat');
        // req['source'] = modifyParams ? 'ICE_WEB' : this.config.getSource();
        req['apiKey'] = this.config.get('apiKey');
        req['apiSecret'] = this.config.get('apiSecret');
        if (serviceName === 'getPatientDemography' || serviceName === 'getRxHistory') {
            req['type'] = 'inode';
        }
        if (serviceName === 'IntegratedCustomerExpService') {
            req['responseFormat'] = 'XML';
            req['securityType'] = 'apiKey';
        }
        if (modifyParams || serviceName === 'getPaymentProfile' || serviceName === 'addPaymentCard' || serviceName === 'addProfile') {
            req['responseFormat'] = 'JSON';
            req['securityType'] = 'apiKey';
            if (serviceName === 'getPaymentProfile') {
                req['type'] = 'retlegget';
            }
            if (serviceName === 'addPaymentCard' || serviceName === 'addProfile') {
                req['type'] = 'retleg';
            }
        }
        if (serviceName === 'ProfileService') { }
        if (opName === 'webContent') {
            req['apiSecret'] = this.config.get('servicesApiSecret');
            req['apiKey'] = this.config.get('servicesApiKey');
            req['appName'] = 'CVS_WEB';
            req['lineOfBusiness'] = 'RETAIL';
            req['channelName'] = 'MOBILE';
            req['version'] = '2.0';
            delete req['source'];
        }
        if (serviceName === 'refreshToken') { }
        if (serviceName === 'prefetchRxStatusSummary') {
            req['source'] = 'MDP_WEB';
            req['appName'] = 'MDP_WEB';
            req['apiKey'] = this.config.get('mdp');
            req['responseFormat'] = 'JSON';
            req['release'] = 'JULY';
        }
        return req;
    }
    post(serviceName, queryParams, request, headersObj) {
        let url = this.getServiceUrl(serviceName);
        if (queryParams !== null && Object.keys(queryParams).length !== 0) {
            url = url + '?' + this.getQueryString(queryParams);
        }
        let post;
        if (headersObj) {
            const httpOptions = {
                headers: headersObj
            };
            post = this.http.post(url, request, httpOptions);
        }
        else {
            post = this.http.post(url, request);
        }
        return post;
    }
    getJsonp(queryParams) {
        const QueryParams = queryParams;
        return this.http.jsonp(QueryParams, 'callback');
    }
    get(serviceName, params, headers) {
        const options = {};
        if (headers) {
            options.headers = headers;
        }
        let url = this.getServiceUrl(serviceName);
        if (params !== null && Object.keys(params).length !== 0) {
            url = url + '?' + this.getQueryString(params);
        }
        return this.http.get(url, options);
    }
    getQueryString(queryParams) {
        let ret = '';
        if (queryParams) {
            for (const key of Object.keys(queryParams)) {
                ret += key + '=' + queryParams[key] + '&';
            }
            if (ret.length > 0) {
                ret = ret.substring(0, (ret.length - 1));
            }
        }
        return ret;
    }
}
ApiService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ApiService_Factory() { return new ApiService(i0.ɵɵinject(i1.ConfigService), i0.ɵɵinject(i2.HttpClient)); }, token: ApiService, providedIn: "root" });
